const DOMAIN_ROOT_ROUTE = "/w/:workspaceId/batch-messages";

export const BATCH_MESSAGING_ROUTES = {
    select: `${DOMAIN_ROOT_ROUTE}/send/upload`,
    fileUpload: `${DOMAIN_ROOT_ROUTE}/send/upload/file`,
    manualInput: `${DOMAIN_ROOT_ROUTE}/send/upload/copy-paste`,
    importPatientList: `${DOMAIN_ROOT_ROUTE}/send/upload/import-patient-list`,
    demographicsReview: `${DOMAIN_ROOT_ROUTE}/send/review/:batchId`,
    compose: `${DOMAIN_ROOT_ROUTE}/send/compose/:batchId`,
};
